(function () {
    angular.module('tmx-app').directive('tmxLocationInput', [tmxLocationInput]);

    function tmxLocationInput() {
        var directive = {
            restrict: 'E'
        };
        directive.controller = ["$scope", "$mdDialog", "$state", "LocationService", "tmxUtility", tmxLocationInputCtrl];
        directive.controllerAs = "tmxLocationInputCtrl";
        directive.scope = {
            value: "=",
            label: "@",
            name: "@",
            gridData: "=",
            disabledNodes: "=",
            form: "=",
            required: "@",
            readonly: "=",
            disabled: "=",
            onChange: '&'
        };
        directive.replace = "true";
        directive.templateUrl = "common/directives/tmxlocationinput/tmxlocationinput.html";

        return directive;
    }

    function tmxLocationInputCtrl($scope, $mdDialog, $state, LocationService, tmxUtility) {
        var vm = this;
        vm.scope = $scope;
        var exists = tmxUtility.exists;
        function selectItem(id) {
            if ($scope.gridData != null && $scope.gridData.data != null)
                for (var i = 0; i < $scope.gridData.data.length; i++) {
                    if ($scope.gridData.data[i].LocationId == id) {
                        $scope.selectedItem = $scope.gridData.data[i];
                        break;
                    }
                }
        }
        vm.onchange = function (item) {
            if (angular.isFunction($scope.onChange())) {
                $scope.onChange()($scope.value, $scope);
            }
        };

        if (exists($scope.value))
            selectItem($scope.value);

        vm.locationTreeGridDialog = function (ev) {
            if (!vm.scope.readonly) {
                $mdDialog.show({
                    locals: { selectedItem: angular.copy($scope.selectedItem), gridData: $scope.gridData, disabledNodes: $scope.disabledNodes },
                    controller: ["$scope", "$mdDialog", "$state", 'LocationService', 'selectedItem', 'gridData', 'tmxUtility', 'disabledNodes', DialogController],
                    controllerAs: 'dialogCtrl',
                    template: '<md-dialog ng-cloak flex="80" style="max-width:600px"><form><md-dialog-content style="overflow: overlay !important;"><kendo-treelist id="grid" options="dialogCtrl.mainGridOptions"></kendo-treelist>    </md-dialog-content></form></md-dialog>',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true
                }).then(function (dataItem) {
                    $scope.selectedItem = dataItem;
                    $scope.value = dataItem.LocationId;
                });
            }
        }

        vm.clear = function () {
            $scope.selectedItem = null;
            $scope.value = null;
        }

        function value() {
            return $scope.value;
        }
        function change(newValue, oldValue) {
            if ((exists(newValue) || exists(oldValue)) && newValue != oldValue) {
                selectItem(newValue);
                $scope.$emit("reloadApplicationData", "");
            }
        }
        $scope.$watch(value, change);
    }//end of location ctrl controller

    function DialogController($scope, $mdDialog, $state, LocationService, selectedItem, gridData, tmxUtility, disabledNodes) {


        var obj = this;
        obj.mainGridOptions = {
            dataSource: {
                schema: schema,
                sort: [{ field: "ParentLocationId", dir: "asc" }, { field: "LocationName", dir: "asc" }],
            },
            filterable: true
        };
        obj.mainGridOptions.dataBound = onDataBound;
        obj.mainGridOptions.dataSource.data = gridData;
        obj.mainGridOptions.selectable = true;
        obj.mainGridOptions.preventDefault = true;
        obj.mainGridOptions.columns = [];
        obj.getLookupName = LocationService.getLookupName;
        obj.getParentName = LocationService.getParentName;
        obj.filterString = LocationService.filterString;

        obj.getLocationName = LocationService.formatLocationName;
        var applyClassOnRows = tmxUtility.applyClassOnRows;
        var findItems = tmxUtility.findItems;
        var exists = tmxUtility.exists;
        var currentParentId;
        obj.disabledItems = [];
        obj.date = new Date().toJSON();
        obj.mainGridOptions.columns = [{
            field: "LocationName",
            title: "LocationName",
            template: "\{\{ dialogCtrl.filterString(dataItem.LocationName) \}\}"
        },
            // {
            //     field: "LocationCode",
            //     title: "LocationCode",
            //     template:"\{\{ dialogCtrl.filterString(dataItem.LocationCode) \}\}"
            // },
            // {
            //     field: "ParentLocationId",
            //     title: "ParentID",
            //     template:"{{dialogCtrl.getParentName(#=ParentLocationId#)}}"
            // },
            // {
            //     field: "LocationTypeLkp",
            //     title: "Type",
            //     template:"{{dialogCtrl.getLookupName(#=LocationTypeLkp#)}}"
            // }
        ]

        obj.mainGridOptions.change = function (e) {
            var selectedRows = this.select();
            var item = this.dataItem(selectedRows[0]);
            // if(item.EffectiveEndDate<obj.date)
            //   obj.deselect(item);
            if (obj.disabledItems.length <= 0)// if no disabled selection then just return the clicked item
                $scope.hide(item);
            else if (obj.disabledItems.length > 0) {//otherwise, only if there are some disabled items then see if current item is one of disabled items
                var isDisabled = findItems("LocationId", item.LocationId, obj.disabledItems).length > 0;
                if (isDisabled) {//if yes then unselect it and select the previous deselected item
                    applyClassOnRows(e.sender, "LocationId", item.LocationId, "k-state-selected k-state-selecting", true);
                    if (exists(selectedItem))
                        applyClassOnRows(e.sender, "LocationId", selectedItem.LocationId, "k-state-selected k-state-selecting");
                }
                else {//else it  means item is valid to return so don't hesitate
                    $scope.hide(item);
                }
            }
        }
        $scope.hide = function (item) {
            $mdDialog.hide(item);
        }
        function onDataBound(arg) {

            if (exists(selectedItem)) {
                expandItem(arg.sender, selectedItem);
                applyClassOnRows(arg.sender, "LocationId", selectedItem.LocationId, "k-state-selected k-state-selecting");
            }
            obj.deselect = function (item) {
                disableSelection(arg.sender, item, obj.disabledItems);
            }
            if (exists(disabledNodes))
                disabledNodes.forEach(obj.deselect);
        }
        function expandItem(kendoTree, item) {
            if (!exists(item.ParentLocationId) || item.ParentLocationId == null) {
                return;
            }
            var items = kendoTree.dataItems();
            var parent = findItems("LocationId", item.ParentLocationId, items)[0];
            expandItem(kendoTree, parent);
            var parentRow = kendoTree.element.find("tr[data-uid=" + parent.uid + "]");
            kendoTree.expand(parentRow);
        }
        function isValidLoc(loc) {
            return exists(loc) && exists(loc.LocationId);
        }
        function disableSelection(kendoTree, item, arr) {
            var list = kendoTree.dataItems();
            function removeKids(item, index, array) {
                var children = findItems("ParentLocationId", item.LocationId, list);
                removeChildrenRecur(children);
            }
            function removeSelf(item, index, array) {
                var index = list.indexOf(item);
                if (index >= 0 && isValidLoc(item)) {
                    arr.push(item);
                }
                //list.splice(index,1);
            }
            function removeChildrenRecur(items) {
                items.forEach(removeKids);
                items.forEach(removeSelf);
            }
            removeChildrenRecur([item]);
            if (isValidLoc(item))
                arr.push(item);
        }
    }
    var schema = {
        data: "data",
        total: "Total",
        model: {
            id: "LocationId",
            parentId: "ParentLocationId",
            fields: {
                LocationId: {
                    type: "number",
                    editable: false,
                    nullable: false
                },
                TenantId: {
                    nullable: true,
                    type: "number"
                },
                ParentLocationId: {
                    nullable: true,
                    type: "number"
                },
                ParentLocationName: {
                    nullable: true,
                    type: "string"
                },
                LocationCode: {
                    nullable: true,
                    type: "string"
                },
                LocationName: {
                    nullable: true,
                    type: "string"
                },
                LocationTypeLkp: {
                    nullable: true,
                    type: "number"
                },
                status: {
                    type: "string"
                }
            }
        }
    }

})();